<template>
  <div>
    <div class="icon-box" @click="openScheduleTable">
      <ScheduleIcon />
      <span class="icon-txt">편성표</span>
    </div>
    <portal to="info-popup" v-if="isOpenScheduleTable">
      <div class="info-popup-wrapper">
        <common-header :title="'[' + contentInfo.channelname + ']채널 편성표'" :is-back-btn="false" :is-close-btn="true" :close-fn="closeScheduleTable"></common-header>
        <div class="schedule-wrap">
          <div class="schedule-list">
            <ul>
              <li v-for="(epg, index) in scheduleList" :key="'epg_' + index" :class="epgsStartTime(present[0].starttime) === epgsEndTime(epg.endtime) && epg.state==='past' ? 'on' : epg.state !== 'past' ? '' : 'off'">
                  <span class="schedule-info">
                    <span class="schedule-txt">{{epg.title}}</span>
                    <span class="schedule-time">{{ epgsStartTime(epg.starttime) }} - {{ epgsEndTime(epg.endtime) }}</span>
                  </span>
                <div class="schedule-icon">
                  <!-- 다시보기 -->
                  <a v-if="epg.state === 'past' && epg.programid"
                     :href="epg.state === 'past' ? '/player/vod?programid=' + epg.programid : ''"
                     class="schdule-icon-replay">다시보기</a>
                  <!-- 방송중 -->
                  <a v-else-if="epg.state === 'present'" class="schdule-icon-onair" @click.prevent="clickBroadcast()">시청하기</a>
                  <!-- 방송예약 -->
                  <div v-else-if="epg.state === 'future'" class="check-style02">
                    <alarm-button :content-info="epg"></alarm-button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </portal>
  </div>
</template>

<script>
import ScheduleIcon from '@/assets/svg/common/ic-live-schd-off.svg'
import { get } from 'lodash'
import { infiniteScroll } from '@/common/directives'
import { LiveInfoService } from '@/common/api/api.service'
import AlarmButton from '@/components/play/AlarmButton'
// import { disableBodyScroll, enableBodyScroll } from '@/common/util/ui.utils'
import { popupInsideThePlayerOpen, popupInsideThePlayerClose } from '@/common/util/ui.utils'
import utils from '@/common/util/utils'
import CommonHeader from '@/components/header/template/commonHeader'
import { PATH_NAME_PLAYER } from '@/common/router.const'
export default {
  name: 'IconBoxSchedule',
  components: {
    CommonHeader,
    AlarmButton,
    ScheduleIcon
  },
  props: {
    contentInfo: {
      type: Object
    }
  },
  directives: {
    infiniteScroll
  },
  data () {
    return {
      today: new Date(),
      isOpenScheduleTable: false,
      scheduleList: [],
      startDate: '',
      endDate: '',
      offset: 0,
      limit: 30,
      present: ''
      // endOfList: false
    }
  },
  methods: {
    dateFormat (year, date, time) {
      return year + '-' + date + ' ' + time + ':00'
    },
    pad (num, width) {
      let numStr = num + ''
      return numStr.length >= width ? numStr
        : new Array((width - numStr.length) + 1).join('0') + numStr
    },
    getEpgType (data) {
      let tempSt = data.starttime.match(/^(\d+)-(\d+)-(\d+) (\d+):(\d+)$/)
      let tempEt = data.endtime.match(/^(\d+)-(\d+)-(\d+) (\d+):(\d+)$/)
      let currentTime = this.today / (1000 * 60)
      let startTime = new Date(tempSt[1], tempSt[2] - 1,
        tempSt[3], tempSt[4], tempSt[5]).getTime() / (1000 * 60)
      let endTime = new Date(tempEt[1], tempEt[2] - 1,
        tempEt[3], tempEt[4], tempEt[5]).getTime() / (1000 * 60)
      if (currentTime > new Date(endTime)) {
        return 'past' // 과거
      } else if (currentTime < new Date(startTime)) {
        return 'future' // 미래
      }
      return 'present' // 현재
    },
    epgsStartTime (sTime) {
      return sTime.substring(sTime.length - 5, sTime.length)
    },
    // 종료시간
    epgsEndTime (eTime) {
      return eTime.substring(eTime.length - 5, eTime.length)
    },
    openScheduleTable () {
      this.$router.push({
        name: PATH_NAME_PLAYER,
        params: {
          section: 'live'
        },
        query: {
          channelid: this.$route.query.channelid,
          isSchedule: 'y'
        }
      })
    },
    closeScheduleTable () {
      this.$router.back()
    },
    setData () {
      LiveInfoService.getEpgs({
        channelid: this.contentInfo.channelid,
        startdatetime: this.startDate,
        enddatetime: this.endDate,
        offset: this.offset,
        limit: this.limit
      }).then(({ data }) => {
        data.list.map((res) => {
          res.state = this.getEpgType(res)
        })
        let resList = get(data, 'list', [])
        this.offset += this.limit
        this.scheduleList = this.scheduleList.concat(resList)
        this.present = this.scheduleList.filter((res) => {
          if (res.state === 'present') {
            return res
          }
        })
      })
    },
    clickBroadcast () {
      let url = 'player/live?channelid=' + this.contentInfo.channelid
      utils.common.checkInstallApps(url)
    }
  },
  created () {
    let current = new Date()
    let currentDate = this.pad(current.getMonth() + 1, 2) + '-' + this.pad(current.getDate(), 2)
    let time = this.pad(current.getHours(), 2)
    let tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    let tomorrowDate = this.pad(tomorrow.getMonth() + 1, 2) + '-' + this.pad(tomorrow.getDate(), 2)
    this.startDate = this.dateFormat(current.getFullYear(), currentDate, time)
    this.endDate = this.dateFormat(tomorrow.getFullYear(), tomorrowDate, time)
    if (this.$route.query.isSchedule === 'y') {
      popupInsideThePlayerOpen()
      this.isOpenScheduleTable = true
    } else {
      popupInsideThePlayerClose()
      this.isOpenScheduleTable = false
    }
  },
  watch: {
    isOpenScheduleTable (newVal) {
      if (newVal === true) {
        this.setData()
      } else {
        this.scheduleList = []
        this.offset = 0
      }
    }
  },
  beforeDestroy () {
    // enableBodyScroll()
    // scheduleTableOpen()
  }
}
</script>

<style scoped>
  .info-popup-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 5000;
  }
  .schedule-wrap {
    width: 100%;
    height: auto;
  }

  /*------------------------------------*\
      서브 상단 header : home-gnb.css와 동일 -> 추후 정리
  \*------------------------------------*/
  .hd-title{
    display: block;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    text-align: center;
  }

  /*------------------------------------*\
      알림
  \*------------------------------------*/
  .schedule-list {
    position: relative;
    width: 100%;
    height: auto;
  }
  /* 스케쥴 리스트 */
  .schedule-list ul{
    display: flex;
    flex-direction: column;
  }
  .schedule-list li{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 26px 15px;
    border-bottom: 1px solid #2f2f2f;
  }
  .schedule-list li.off {
    display: none;
  }
  .schedule-info{
    flex: 1;
    display: block;
  }
  .schedule-txt{
    display: block;
    display: -webkit-box;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-word;
    color: #a5a5a5;
    font-size: 13px;
    line-height: 18px;
    max-height: 36px;
  }
  .schedule-time{
    display: block;
    margin-top: 6px;
    color: #a5a5a5;
    font-size: 12px;
    line-height: 13px;
  }

  /* 스케쥴 아이콘 - 다시보기, 방송중, 알림 */
  .schedule-icon{
    text-align: center;
    font-size: 11px;
    line-height: 24px;
  }
  .schdule-icon-replay{
    display: block;
    padding: 0 10px;
    border: 1px solid #fff;
    border-radius: 30px;
    color: #fff;
  }
  .schdule-icon-onair{
    display: block;
    padding: 0 10px;
    color: #fff;
    border: 1px solid #1351f9;
    background-color: #1351f9;
    border-radius: 30px
  }
  .schdule-icon-alarm{
    display: block;
    height: 24px;
    overflow: hidden;
    margin-left: auto;
    outline: none;
  }
</style>
